import {
  getNotificationCountdownInterval,
  setNotificationCountdownInterval
} from "./store";

import { resetToLanding } from "./navigation";
import { AvailableLanguages, TRANSLATIONS } from "./i18n/i18n";

export function showTimeoutMessage(currentLanguage: AvailableLanguages) {
  showNotification(
    "error",
    TRANSLATIONS[currentLanguage].validation.timeout,
    10
  );
}

export function showNotification(
  type: "error" | "success",
  message: string,
  timeout: number = 10
) {
 
  const existingNotification = document.getElementById("notificationTimeout");
  if (existingNotification) {
    existingNotification.remove();
    if (getNotificationCountdownInterval()) {
      clearInterval(getNotificationCountdownInterval()!);
      setNotificationCountdownInterval(null);
    }
  }

  // Create notification element
  const timeoutMessage = document.createElement("div");
  timeoutMessage.id = "notificationTimeout";
  const notificationClass =
    type === "error"
      ? "bg-red-100 border border-red-400 text-red-700"
      : "bg-green-100 border border-green-400 text-green-700";

  timeoutMessage.className = `fixed top-4 left-1/2 -translate-x-1/2 ${notificationClass} px-4 py-3 rounded z-[200] flex items-center shadow-lg`;
  timeoutMessage.innerHTML = `
    <p class="mr-8">${message}</p>
    <div class="countdown font-mono text-lg">${timeout}</div>
  `;

  document.body.appendChild(timeoutMessage);

  // Avvia il countdown
  let secondsLeft = timeout;
  const countdownElement = timeoutMessage.querySelector(".countdown");

  const countdownInterval = setInterval(() => {
    secondsLeft--;
    if (countdownElement) countdownElement.textContent = secondsLeft.toString();
    if (secondsLeft <= 0) {
      clearInterval(countdownInterval);
      setNotificationCountdownInterval(null);
      timeoutMessage.remove();
      resetToLanding();
    }
  }, 1000);

  setNotificationCountdownInterval(countdownInterval);

  // Fade-in animation
  requestAnimationFrame(() => {
    timeoutMessage.style.opacity = "0";
    timeoutMessage.style.transform = "translate(-50%, -20px)";
    timeoutMessage.style.transition = "all 0.3s ease-out";
    requestAnimationFrame(() => {
      timeoutMessage.style.opacity = "1";
      timeoutMessage.style.transform = "translate(-50%, 0)";
    });
  });
}
